webpackJsonp([463],{

/***/ 1703:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(2233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/can-vux-used-in-weapp-10.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] can-vux-used-in-weapp-10.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f318c6c", Component.options)
  } else {
    hotAPI.reload("data-v-4f318c6c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2233:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 能否在微信小程序里使用")]), _vm._v(" "), _c('p', [_vm._v("Sorry，不能。微信小程序是个相对封闭的平台，无法简单地适配也没有计划支持小程序版本。")]), _vm._v(" "), _c('p', [_vm._v("目前企业主体用户可以使用 "), _c('code', [_vm._v("web-view")]), _vm._v(" 组件直接显示 web 页面，间接地使用 VUX。")]), _vm._v(" "), _c('h2', [_vm._v("mpvue 解决方案能否直接迁移 VUX")]), _vm._v(" "), _c('p', [_vm._v("目前 "), _c('a', {
    attrs: {
      "href": "http://mpvue.com/"
    }
  }, [_vm._v("mpvue")]), _vm._v(" 还不支持 "), _c('code', [_vm._v("slot")]), _vm._v("、"), _c('code', [_vm._v("slot-scope")]), _vm._v("，因此迁移有难度，并且小程序存在较多差异，暂未计划。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f318c6c", module.exports)
  }
}

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1703);

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX 能否在微信小程序里使用 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 463.9f3da817.js